let ArticleListing = {};

ArticleListing = {
  init() {
    let articleListingSlider = $('.js-article-listing-slider');

    if(articleListingSlider.length === 0) {
      return;
    }

    $.each(articleListingSlider, function() {
      let $slider = $(this);

      let options = {
        contain: true,
        wrapAround: false,
        cellAlign: 'left',
        groupCells: false,
        prevNextButtons: true,
        pageDots: false,
        dragThreshold: 10,
        on: {
          ready: function() {
            $slider.addClass('first-el flickity-ready').removeClass('hidden');
          },
        },
      };

      if (matchMedia('screen and (max-width: 1023px)').matches) {
        options = {
          contain: true,
          wrapAround: false,
          cellAlign: 'left',
          groupCells: false,
          prevNextButtons: true,
          pageDots: false,
          dragThreshold: 10,
          on: {
            ready: function() {
              $slider.addClass('first-el flickity-ready').removeClass('hidden');
            },
          },
        };
      }

      let flkty = $slider.flickity(options);
      let flktyData = $slider.data('flickity');
			
      flkty.on('change.flickity', function () {

        if (matchMedia('screen and (max-width: 1023px)').matches) {
          if (flktyData.selectedIndex == 0) {
            $slider.addClass('first-el');
          } else {
            $slider.removeClass('first-el');
          }
        }
      });
    });
  },
}

ArticleListing.init();

$(window).resize(function () {
  ArticleListing.init();
});

window.ArticleListing = ArticleListing;



// WEBPACK FOOTER //
// ./scripts/components/sliders/article-listing.js